export default function Footer() {
  return (
    <footer id="contacto" className="bg-[#2C3E2F] relative overflow-hidden">
      {/* Decorative World Map Pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 400">
          <path
            d="M 100 200 L 200 150 L 300 180 L 400 160 L 500 190 L 600 170 L 700 200 L 800 180 L 900 210 L 1000 190 L 1100 200"
            stroke="white"
            strokeWidth="1"
            fill="none"
          />
          <circle cx="200" cy="150" r="3" fill="white" />
          <circle cx="400" cy="160" r="3" fill="white" />
          <circle cx="600" cy="170" r="3" fill="white" />
          <circle cx="800" cy="180" r="3" fill="white" />
          <circle cx="1000" cy="190" r="3" fill="white" />
        </svg>
      </div>

      {/* Main Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Left Section - Brand */}
          <div className="md:col-span-4">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/c925375f38344b4ce5e0a3111721797b.png" 
                alt="Masaje de Vida" 
                className="h-16 w-auto mb-4"
              />
            </div>
            <p className="font-serif text-3xl text-white leading-tight mb-6">
              Tu bienestar es nuestra pasión
            </p>
            <p className="text-white/70 text-sm leading-relaxed">
              20 años transformando el estrés en vitalidad con masajes profesionales en el corazón de Getafe.
            </p>
          </div>

          {/* Right Section - Links Grid */}
          <div className="md:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            {/* Servicios */}
            <div>
              <h4 className="font-sans font-bold text-white mb-4 text-sm uppercase tracking-wider">
                Servicios
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="#servicios" className="text-white/80 hover:text-white transition-colors text-sm">
                    Masaje Descontracturante
                  </a>
                </li>
                <li>
                  <a href="#servicios" className="text-white/80 hover:text-white transition-colors text-sm">
                    Masaje Relajante
                  </a>
                </li>
                <li>
                  <a href="#servicios" className="text-white/80 hover:text-white transition-colors text-sm">
                    Masaje Deportivo
                  </a>
                </li>
              </ul>
            </div>

            {/* Información */}
            <div>
              <h4 className="font-sans font-bold text-white mb-4 text-sm uppercase tracking-wider">
                Información
              </h4>
              <ul className="space-y-3">
                <li>
                  <a href="#sobre-nosotros" className="text-white/80 hover:text-white transition-colors text-sm">
                    Sobre Nosotros
                  </a>
                </li>
                <li>
                  <a href="#reserva" className="text-white/80 hover:text-white transition-colors text-sm">
                    Reservar Cita
                  </a>
                </li>
                <li>
                  <a href="#contacto" className="text-white/80 hover:text-white transition-colors text-sm">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>

            {/* Contacto */}
            <div>
              <h4 className="font-sans font-bold text-white mb-4 text-sm uppercase tracking-wider">
                Contacto
              </h4>
              <ul className="space-y-3">
                <li className="text-white/80 text-sm">
                  <i className="ri-map-pin-line mr-2"></i>
                  C. Gral. Castaños, 1
                </li>
                <li className="text-white/80 text-sm">
                  Getafe, Madrid
                </li>
                <li>
                  <a href="tel:643218449" className="text-white/80 hover:text-white transition-colors text-sm">
                    <i className="ri-phone-line mr-2"></i>
                    643 218 449
                  </a>
                </li>
              </ul>
            </div>

            {/* Horario */}
            <div>
              <h4 className="font-sans font-bold text-white mb-4 text-sm uppercase tracking-wider">
                Horario
              </h4>
              <ul className="space-y-3 text-white/80 text-sm">
                <li>Lunes - Viernes</li>
                <li>10:00 - 20:00</li>
                <li className="pt-2">Sábados</li>
                <li>10:00 - 14:00</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            {/* Copyright */}
            <div className="text-white/70 text-xs">
              © 2025 Masaje de Vida. Todos los derechos reservados.
            </div>

            {/* Social Icons */}
            <div className="flex items-center space-x-6">
              <a
                href="https://wa.me/34643218449"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.google.com/maps"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center text-white hover:bg-white hover:text-[#2C3E2F] transition-all duration-300 cursor-pointer"
                aria-label="Google Maps"
              >
                <i className="ri-map-pin-line text-lg"></i>
              </a>
            </div>

            {/* Legal Links */}
            <div className="flex items-center space-x-6 text-white/70 text-xs">
              <span className="hover:text-white transition-colors">
                Grupo Globaltis
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}